/**
 * Action used to open the modal.
 * @param {String} ACTION_KEY String modal key.
 * @param {Object} data Object
 * @param {Function} onSuccessCallback Function called when an action is succefuly executed.
 */
export function openModal(ACTION_KEY, data, onSuccessCallback) {
    return {
        type: `${ACTION_KEY}_OPEN`,
        payload: {
            data,
            onSuccessCallback,
        },
    };
}

/**
 * Action used to close the modal.
 * @param {String} ACTION_KEY String modal key.
 */
export function closeModal(ACTION_KEY) {
    return {
        type: `${ACTION_KEY}_CLOSE`,
    };
}
